module.exports = __webpack_public_path__ + "img/2.1.d4554e1e.png";